module.exports = __webpack_public_path__ + "img/logo-BNI-46-1.2bd31f32.png";